import { StorageFactory } from '../storage/storage.repository'
import type { AuthStorage } from './auth-storage.interface'
import { AuthConfig } from './auth.constants'
import type { AuthResponse } from './auth.interface'

export class AuthStorageRepository implements AuthStorage {
  static #authStorageRepository: AuthStorageRepository
  static getInstance() {
    if (!AuthStorageRepository.#authStorageRepository) {
      AuthStorageRepository.#authStorageRepository = new AuthStorageRepository()
    }
    return AuthStorageRepository.#authStorageRepository
  }
  saveToken(data: AuthResponse): void {
    const storage = new StorageFactory().create(AuthConfig.storageSetup.storage, AuthConfig.storageSetup.config)
    storage.set(AuthConfig.storageSetup.key, data.token)
    storage.set(AuthConfig.storageSetup.key, data.token)
  }

  getToken(): string | null {
    const storage = new StorageFactory().create(AuthConfig.storageSetup.storage, AuthConfig.storageSetup.config)
    return storage.get(AuthConfig.storageSetup.key)
  }

  removeToken(): void {
    const storage = new StorageFactory().create(AuthConfig.storageSetup.storage, AuthConfig.storageSetup.config)
    storage.remove(AuthConfig.storageSetup.key)
  }
}
